<template>
  <ViewContainer :title="$t('insights.dashboard')" :subtitle="subtitle">
    <template v-slot:append>
      <InsightsLastUpdatedLabel class="align-end" />
    </template>
    <v-row class="ma-0 pa-0 px-n2 mx-n2 mt-n2">
      <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="px-2 my-2">
        <RevTrends data-tourid="dashboard-content-trends" />
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="6"
        lg="6"
        xl="6"
        class="px-2 my-2"
        v-if="routinesIsEnabledForCurrentOrg"
      >
        <RoutineTrends data-tourid="dashboard-content-trends" />
      </v-col>

      <v-col
        cols="12"
        sm="12"
        md="6"
        lg="6"
        xl="6"
        class="px-2 my-2"
        data-testid="insightsView-col-predictedFinancialImpact"
      >
        <PredictedFinancialImpactWidget
          data-tourid="dashboard-predicted-financial-impact"
        />
      </v-col>

      <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="px-2 my-2">
        <PotentialImpacts data-tourid="dashboard-potential-impacts" />
      </v-col>

      <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="px-2 my-2">
        <RoutinesCompletion data-tourid="dashboard-routines-completion" />
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="px-2 my-2">
        <LeadingCategories data-tourid="dashboard-leading-categories" />
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="px-2 my-2">
        <LongestUnresolvedFindings
          data-tourid="dashboard-longest-unresolved-findings"
        />
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="px-2 my-2">
        <RoutinesWithMostFindings
          data-tourid="dashboard-longest-unresolved-findings"
        />
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="px-2 my-2">
        <Keywords />
      </v-col>
    </v-row>
  </ViewContainer>
</template>

<script>
import { mapGetters } from 'vuex'

import userMixin from '@/mixins/userMixin.vue'
import mixin from '@/mixins/mixin.vue'
import InsightsLastUpdatedLabel from '@/components/InsightsLastUpdatedLabel.vue'

import RevTrends from './Widgets/RevTrends.vue'
import RoutineTrends from './Widgets/RoutineTrends.vue'
import LeadingCategories from './Widgets/LeadingCategories/LeadingCategories.vue'
import Keywords from './Widgets/Keywords/Keywords.vue'

import PotentialImpacts from './Widgets/PotentialImpacts/PotentialImpacts.vue'
import PredictedFinancialImpactWidget from './Widgets/PredictedFinancialImpactWidget.vue'
import RoutinesCompletion from './Widgets/RoutinesCompletion/RoutinesCompletion.vue'
import LongestUnresolvedFindings from './Widgets/LongestUnresolvedFindings/LongestUnresolvedFindings.vue'
import RoutinesWithMostFindings from './Widgets/RoutinesWithMostFindings.vue'
import ViewContainer from '@/components/Core/Layout/ViewContainer.vue'

export default {
  name: 'InsightsView',

  mixins: [mixin, userMixin],

  components: {
    ViewContainer,
    RevTrends,
    RoutineTrends,
    LeadingCategories,
    Keywords,
    PotentialImpacts,
    PredictedFinancialImpactWidget,
    RoutinesCompletion,
    LongestUnresolvedFindings,
    InsightsLastUpdatedLabel,
    RoutinesWithMostFindings,
  },

  computed: {
    ...mapGetters(['account', 'organization']),

    routinesIsEnabledForCurrentOrg() {
      return this.organization?.featuresEnabled__routines ?? false
    },

    subtitle() {
      const isAdmin = this.account.isAdmin || this.account.isOrganizationAdmin
      return isAdmin
        ? this.$t('insights.subtitle_org_admin', {
            name: this.name,
            interpolation: { escapeValue: false },
          })
        : this.$t('insights.subtitle', {
            name: this.name,
            interpolation: { escapeValue: false },
          })
    },

    name() {
      return this.getAvatarName(this.account)
    },
  },
}
</script>
